export default __webpack_public_path__ + "static/media/bg3.d887fe2d.png";